import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { FileResponse } from '../modules/tcm-core.module/models/files/file-response';

@Injectable({
  providedIn: 'root'
})
export class ClaimBatchService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public async downloadAndSaveDocumentFileAsync(id: number | string): Promise<any> {
    try {
      var fileResponse = await this.downloadDocumentFileBlobAsync(id);

      fileResponse.save();
    }
    catch (e) {
    }
  }

  public createClaimBatchFromClaims(claimIds: number[], claimBatchDate: Date, timeout: Promise<any>): Promise<number> {
    return this.httpClient.postJsonAsync(`ClaimBatches/CreateClaimBatchFromClaims`, { claimIds, claimBatchDate }, timeout);
  }

  public generateEldaDocumentAsync(claimBatchId: number, timeout: Promise<any>): Promise<FileResponse> {
    return this.httpClient.getFileAsync('ClaimBatches/GenerateEldaDocument?claimBatchId=' + claimBatchId, {}, timeout);
  }

  public downloadEldaDocumentAsync(claimBatchId: number, timeout: Promise<any>): Promise<FileResponse> {
    return this.httpClient.getFileAsync('ClaimBatches/DownloadEldaDocument?claimBatchId=' + claimBatchId, {}, timeout);
  }

  public generateCoverLetterAsync(claimBatchId: number, timeout: Promise<any>): Promise<number> {
    return this.httpClient.getJsonAsync('ClaimBatches/GenerateCoverLetter?claimBatchId=' + claimBatchId, {}, timeout);
  }

  public generateInvoiceAsync(claimBatchId: number, timeout: Promise<any>): Promise<number> {
    return this.httpClient.getJsonAsync('ClaimBatches/GenerateInvoice?claimBatchId=' + claimBatchId, {}, timeout);
  }

  private downloadDocumentFileBlobAsync(id: number | string): Promise<FileResponse> {
    return this.httpClient.getFileAsync(`ClaimBatches/download?id=${id.toString()}`);
  }

  public getCoverLetterReportIdAsync(cancellationToken: Promise<any>): Promise<number> {
    return this.httpClient.getJsonAsync('ClaimBatches/GetCoverLetterReportId', cancellationToken);
  }
  public getInvoiceReportIdAsync(cancellationToken: Promise<any>): Promise<number> {
    return this.httpClient.getJsonAsync('ClaimBatches/GetInvoiceReportId', cancellationToken);
  }

  public removeClaimFromClaimBatch(claimBatchId: number, claimId: number, cancellationToken: Promise<any>): Promise<number> {
	  return this.httpClient.postJsonAsync('ClaimBatches/RemoveClaimFromClaimBatch', { claimBatchId, claimId }, cancellationToken);
  }
}
